import { Expose } from 'class-transformer';
import { SurveyElement } from './element';
import { ActionButton } from '@/models/action-button';

export class SurveyTextareaFieldElement extends SurveyElement {
  @Expose({ name: 'question' })
  title!: string;

  @Expose({ name: 'placeholder' })
  label!: string;

  @Expose()
  isSubmitable?: boolean;

  @Expose({ name: 'action_button' })
  actionButton!: ActionButton;
}
